import { render, staticRenderFns } from "./DriverOnlineStatus.vue?vue&type=template&id=0384f2c6&scoped=true&"
import script from "./DriverOnlineStatus.vue?vue&type=script&lang=js&"
export * from "./DriverOnlineStatus.vue?vue&type=script&lang=js&"
import style0 from "./DriverOnlineStatus.vue?vue&type=style&index=0&id=0384f2c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0384f2c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0384f2c6')) {
      api.createRecord('0384f2c6', component.options)
    } else {
      api.reload('0384f2c6', component.options)
    }
    module.hot.accept("./DriverOnlineStatus.vue?vue&type=template&id=0384f2c6&scoped=true&", function () {
      api.rerender('0384f2c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DispatchDashboard/components/DriverOnlineStatus.vue"
export default component.exports